// src/lib/db.ts
export function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('StoryHighlightsDB', 1);
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains('highlights')) {
        db.createObjectStore('highlights', { keyPath: 'id' });
      }
    };
  });
}

export async function saveHighlights(highlights: any[]): Promise<void> {
  const db = await openDB();
  const tx = db.transaction('highlights', 'readwrite');
  const store = tx.objectStore('highlights');
  await new Promise<void>((resolve, reject) => {
    const clearReq = store.clear();
    clearReq.onsuccess = () => resolve();
    clearReq.onerror = () => reject(clearReq.error);
  });
  for (const highlight of highlights) {
    await new Promise<void>((resolve, reject) => {
      const putReq = store.put(highlight);
      putReq.onsuccess = () => resolve();
      putReq.onerror = () => reject(putReq.error);
    });
  }
  tx.commit();
}

export async function loadHighlights(): Promise<any[]> {
  const db = await openDB();
  const tx = db.transaction('highlights', 'readonly');
  const store = tx.objectStore('highlights');
  return new Promise((resolve, reject) => {
    const getAllReq = store.getAll();
    getAllReq.onsuccess = () => resolve(getAllReq.result);
    getAllReq.onerror = () => reject(getAllReq.error);
  });
}